import { Yii } from "libraries/interfaces/Yii";
import {
    IDescriptionLabels
} from "libraries/module/formbuilder/fields/form-field/components/field-description/field-description.component";
import {
    EProcessReportSearchParts
} from "app_sasha/pages/process-report/components/process-report-search-form/e-process-report-search-parts";

export class Wording {
    public title: string = Yii.t('wui-shared-js', "Journal des incidents - Recherche");
    public titleSummary: string = Yii.t('wui-shared-js', "Journal des incidents - Résumé de la recherche");
    public error: string = Yii.t('wui-shared-js', "Merci de vérifier le formulaire");
    public reset: string = Yii.t('wui-shared-js', "Nouvelle recherche");
    public search: string = Yii.t('wui-shared-js', "Rechercher");
    public modifySearch: string = Yii.t('wui-shared-js', "Modifier la recherche");
    public noRequest: string = Yii.t('wui-shared-js', "Aucun critère de recherche");
    public oneCrit: string = Yii.t('wui-shared-js', "1 critère de recherche");
    public moreCrit: string = Yii.t('wui-shared-js', "%placeholder% critères de recherche");

    public readonly systems: string = Yii.t('wui-shared-js', 'Systèmes');
    public readonly systemDescription: IDescriptionLabels = {
        main: Yii.t('wui-shared-js', 'Systèmes sur lesquels les traitements on été effectués.'),
    };

    public readonly status: string = Yii.t('wui-shared-js', 'Statuts');
    public readonly statusDescription: IDescriptionLabels = {
        main: Yii.t('wui-shared-js', 'Statuts sur lesquels les traitements on été effectués.'),
    };

    public readonly whenType: string = Yii.t('wui-shared-js', 'Type d\'évènement');
    public readonly whenTypeDescription: IDescriptionLabels = {
        main: Yii.t('wui-shared-js', 'Type d\'évènement sur lesquels les traitements on été effectués.'),
    };

    public readonly [EProcessReportSearchParts.whenCreated]: string = Yii.t('wui-shared-js', 'Dates de création');
    public readonly [EProcessReportSearchParts.whenCreatedMin]: string = Yii.t('wui-shared-js', 'Date de création min');
    public readonly [EProcessReportSearchParts.whenCreatedMax]: string = Yii.t('wui-shared-js', 'Date de création max');
    public readonly [EProcessReportSearchParts.whenCancelled]: string = Yii.t('wui-shared-js', 'Dates de d\'annulation');
    public readonly [EProcessReportSearchParts.whenCancelledMin]: string = Yii.t('wui-shared-js', 'Date de d\'annulation min');
    public readonly [EProcessReportSearchParts.whenCancelledMax]: string = Yii.t('wui-shared-js', 'Date de d\'annulation max');

    public readonly dateElements: Partial<IDescriptionLabels> = {
        detailIntroduction: Yii.t('wui-shared-js', 'Pour des recherches plus précises sur les dossiers aériens, utiliser les critères associés au vols. Ce champ supporte les expressions de date :'),
        detailList: [
            Yii.t('wui-shared-js', 'aujourd\'hui : = ;'),
            Yii.t('wui-shared-js', 'début du mois : < ;'),
            Yii.t('wui-shared-js', 'fin du mois : > ;'),
            Yii.t('wui-shared-js', 'dans deux semaines : +2w ;'),
            Yii.t('wui-shared-js', 'dans trois mois : +3m .'),
        ],
    };

    public readonly [EProcessReportSearchParts.whenCreatedMinDescription]: IDescriptionLabels = {
        main: Yii.t('wui-shared-js', 'Pour indiquer la date de création minimale du dossier sur laquelle effectuer la recherche.'),
        ...this.dateElements,
    };

    public readonly [EProcessReportSearchParts.whenCreatedMaxDescription]: IDescriptionLabels = {
        main: Yii.t('wui-shared-js', 'Pour indiquer la date de création maximale du dossier sur laquelle effectuer la recherche.'),
        ...this.dateElements,
    };
    public readonly [EProcessReportSearchParts.whenCancelledMinDescription]: IDescriptionLabels = {
        main: Yii.t('wui-shared-js', 'Pour indiquer la date d\'annulation minimale du dossier sur laquelle effectuer la recherche.'),
        ...this.dateElements,
    };

    public readonly [EProcessReportSearchParts.whenCancelledMaxDescription]: IDescriptionLabels = {
        main: Yii.t('wui-shared-js', 'Pour indiquer la date d\'annulation maximale du dossier sur laquelle effectuer la recherche.'),
        ...this.dateElements,
    };

}
